<script lang="ts" setup>
import { QAvatar, QIcon, QItemSection } from "quasar";
import MItem from "../../MItem";
import { ItemOption } from "./_types";
import MAvatar from "../../MAvatar";

defineProps<{
  item: ItemOption;
  selected?: boolean;
  hasPhoto?: boolean;
  disabled?: boolean;
}>();
</script>
<template>
  <MItem class="select-item" :disabled="disabled">
    <slot name="section" v-bind="{ option: item }" />
    <q-item-section v-if="hasPhoto" avatar>
      <m-avatar :photo-url="item.photoUrl" :name="item.label" />
    </q-item-section>
    <q-icon v-else-if="item.icon" color="black" class="q-mr-sm" :name="item.icon" />
    <q-item-section
      :class="[
        item.color && `color-${item.color}`,
        item.description && 'm-select-item-with-description',
      ]"
    >
      <div v-if="item.description">
        <p class="m-select-item-label">
          {{ item.label }}
        </p>
        <template v-if="Array.isArray(item.description)">
          <p
            v-for="d in item.description"
            :key="`${item.label}.${d}`"
            class="m-select-item-description"
          >
            {{ d }}
          </p>
        </template>

        <p v-else class="m-select-item-description">
          {{ item.description }}
        </p>
      </div>
      <template v-else>
        {{ item.label }}
      </template>
    </q-item-section>

    <q-item-section v-if="selected" avatar>
      <q-avatar text-color="black" icon="fa-light fa-check" />
    </q-item-section>
    <slot v-if="$slots['option-action']" name="option-action" v-bind="item" />
  </MItem>
</template>
<style lang="scss">
.select-item {
  .q-item__section--side > .q-avatar {
    font-size: 24px;
  }
}
</style>
